"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPPORTUNITY_ACTIVITY_STATUS_CLOSED = exports.OPPORTUNITY_STATUS_WON = exports.OPPORTUNITY_STATUS_WORK_IN_PROGRESS = exports.OPPORTUNITY_STATUS_LOST = exports.OPPORTUNITY_STATUS_OPEN = exports.DEFAULT_COMPANY_STATUS_ACTIVE = exports.DEFAULT_INACTIVE_STATUS = exports.DEFAULT_ACTIVE_STATUS = exports.SUCCESS_MESSAGE = exports.DUPLICATE_CONSTRAINT = exports.PREFERENCE_STATUS_EXCLUDED = exports.PREFERENCE_STATUS_PREFERRED = exports.ENROLLMENT_STATUS_NOT_READY = exports.POLICY_CONFIG_STATUS_IN_PROGRESS = exports.OPPORTUNITY_POLICY_STATUS_CREATED = exports.MEETING_NAME = exports.MEETING_TYPE_KEY = exports.DEFAULT_MEETING_STATUS_COMPLETED = exports.DEFAULT_MEETING_STATUS = exports.DEFAULT_TASK_STATUS = exports.IS_NOT_EDITABLE = exports.IS_EDITABLE = exports.ROLES = exports.DEFAULT_ADMIN_ID = exports.JWT_REFRESH_EXPIRES_IN = exports.JWT_EXPIRES_IN = exports.JWT_SECRET = exports.USER_TYPE_IIRM_EMPLOYEE = exports.DEFAULT_USER_IIRM_EMP_ID = exports.DEFAULT_TPA_SORT_FIELD = exports.DEFAULT_EMPLOYEE_SORT_FIELD = exports.DEFAULT_SORT_FIELD = exports.DEFAULT_ASC_SORT_ORDER = exports.DEFAULT_DESC_SORT_ORDER = exports.DEFAULT_SORT_ORDER = exports.DEFAULT_LIMIT = exports.DEFAULT_PAGE = exports.DEFAULT_ADMIN = exports.DEFAULT_EMPLOYEE_PAGE_LIMIT = exports.DEFAULT_EMPLOYEE_PAGE = exports.DEFAULT_EMPLOYEE_UPDATED_BY = exports.DEFAULT_EMPLOYEE_CREATED_BY = exports.DEFAULT_USER_PASSWORD = exports.DEFAULT_USER_ROLE_ID = exports.TPA_DEFAULT_PAGE_LIMIT = exports.TPA_DEFAULT_PAGE = exports.TPA_ADDRESS_ID = exports.TPA_UPDATED_BY = exports.TPA_CREATED_BY = exports.ADMIN = void 0;
exports.DEFAULT_PHONE_NUMBER = exports.enumRecordType = exports.BROKER_CONTACT_RECORD_TYPE = exports.TPA_CONTACT_RECORD_TYPE = exports.INSURER_CONTACT_RECORD_TYPE = exports.COMPANY_CONTACT_RECORD_TYPE = exports.EMPLOYEE_FIELDS = exports.DEFAULT_APPROVAL_REQUIRED = exports.REASSIGN = exports.IGNORE = exports.UPDATE = exports.MEETING_SUB_TYPE_LID = exports.KNOWLEDGE_STATUS_DELETED = exports.KNOWLEDGE_STATUS_ACTIVE = exports.TPA_STATUS_ACTIVE = exports.DEFAULT_BROKER_ENTITY_NAME = exports.DEFAULT_TPA_ENTITY_NAME = exports.DEFAULT_INSURER_ENTITY_NAME = exports.DEFAULT_CONTACT_ENTITY_NAME = exports.DEFAULT_COMPANY_ENTITY_NAME = exports.COMPANY_DISPLAY_NAME = exports.DEFAULT_EMAIL_KEY = exports.DEFAULT_PHONE_KEY = exports.EMPLOYEE_REPORTEE_ACTION_UPDATE = exports.EMPLOYEE_REPORTEE_ACTION_IGNORE = exports.EMPLOYEE_REPORTEE_ACTION_REASSIGN = exports.ACTIVITY_STATUS_COMPLETED = exports.OPTY_STAGE_WON = exports.OPTY_STAGE_LOST = exports.OPTY_STAGE_OPEN = exports.OPTY_STAGE_WIP = exports.USER_STATUS_DELETED = exports.USER_STATUS_ACTIVE = exports.EMPLOYEE_STATUS_LEAVE = exports.EMPLOYEE_STATUS_INACTIVE = exports.EMPLOYEE_STATUS_ACTIVE = exports.companyNonEditableFields = exports.DEFAULT_BROKER_STATUS_ACTIVE_KEY_ID = exports.DEFAULT_INSURER_STATUS_ACTIVE_KEY_ID = exports.DEFAULT_COMPANY_STATUS_UNDER_REVIEW_KEY_ID = exports.DEFAULT_CONTACT_STATUS_INACTIVE_KEY_ID = exports.DEFAULT_CONTACT_STATUS_ACTIVE_KEY_ID = exports.DEFAULT_TPA_STATUS_ACTIVE_KEY_ID = exports.DEFAULT_RESIDENTIAL_ADDRESS_TYPE_KEY = exports.DEFAULT_INSURER_STATUS_ACTIVE_KEY = exports.DEFAULT_BROKER_STATUS_ACTIVE = exports.DEFAULT_CONTACT_STATUS_INACTIVE_KEY = exports.DEFAULT_CONTACT_STATUS_ACTIVE_KEY = exports.QCR_GENERATION_KEY = exports.OPPORTUNITY_POLICY_STATUS_ACTIVE = void 0;
exports.SEARCH_STRING_FOR_OPPORTUNITIES_FETCH_REGEX = exports.EMPLOYEE_ID_FOR_HIERARCHY_TREE_REGEX = exports.OPPORTUNITY_ACTIVITY = exports.ACTIVITY_KEY = exports.EMPLOYEE_USER_ID = exports.ORGANISATION_ID = exports.USER_EMAIL = exports.DEFAULT_PLANNING = exports.DEFAULT_COMPANY_CONTACT_RECORD_TYPE_KEY = exports.DEFAULT_COMPANY_CONTACT_RECORD_TYPE = exports.RENEWAL_OPPORTUNITY = exports.SALES_OPPORTUNITY = exports.COVERS_REQUIRED_ACTIVITIES = exports.PARTICIPANT_EMPLOYEE_COMPANY_ID = exports.PARTICIPANT_TYPE = exports.MAPPED_DATA_DELETION = exports.TABLE_NAMES = exports.AccessControlMap = exports.FIVE_YEARS = exports.TWO_YEARS = exports.ONE_YEAR = exports.SIX_MONTHS = exports.THREE_MONTHS = exports.MEDIATOR_DETAILS = exports.MEDIATOR_TYPES = exports.INSURER_MEDIATOR_TYPE = exports.TPA_MEDIATOR_TYPE = exports.OPPORTUNITY_TYPES = exports.OPPORTUNITY_STAGES = exports.MASTER_DATA = exports.LOOK_UP_DATA = exports.DEFAULT_TOTAL_KPI_COUNT = exports.CREATED_AT = void 0;
exports.ADMIN = "admin";
exports.TPA_CREATED_BY = "tpa";
exports.TPA_UPDATED_BY = "update tpa";
exports.TPA_ADDRESS_ID = 1;
exports.TPA_DEFAULT_PAGE = 1;
exports.TPA_DEFAULT_PAGE_LIMIT = 10;
exports.DEFAULT_USER_ROLE_ID = 1;
exports.DEFAULT_USER_PASSWORD = "password";
exports.DEFAULT_EMPLOYEE_CREATED_BY = 1;
exports.DEFAULT_EMPLOYEE_UPDATED_BY = 1;
exports.DEFAULT_EMPLOYEE_PAGE = 1;
exports.DEFAULT_EMPLOYEE_PAGE_LIMIT = 10;
exports.DEFAULT_ADMIN = "admin";
exports.DEFAULT_PAGE = 1;
exports.DEFAULT_LIMIT = 10;
exports.DEFAULT_SORT_ORDER = "DESC";
exports.DEFAULT_DESC_SORT_ORDER = "DESC";
exports.DEFAULT_ASC_SORT_ORDER = "ASC";
exports.DEFAULT_SORT_FIELD = "id";
exports.DEFAULT_EMPLOYEE_SORT_FIELD = "employeeId";
exports.DEFAULT_TPA_SORT_FIELD = "id";
exports.DEFAULT_USER_IIRM_EMP_ID = 1;
exports.USER_TYPE_IIRM_EMPLOYEE = "USER_TYPE_IIRM_EMPLOYEE";
exports.JWT_SECRET = "ThisIsSecretVeda";
exports.JWT_EXPIRES_IN = "1h";
exports.JWT_REFRESH_EXPIRES_IN = "7d";
exports.DEFAULT_ADMIN_ID = 1;
exports.ROLES = {
    ADMIN: "admin",
    EMPLOYEE: "employee",
    TPA: "tpa",
    BD: "BD",
};
exports.IS_EDITABLE = "yes";
exports.IS_NOT_EDITABLE = "no";
exports.DEFAULT_TASK_STATUS = "TASK_STATUS_ACTIVE";
exports.DEFAULT_MEETING_STATUS = "MEETING_STATUS_SCHEDULED";
exports.DEFAULT_MEETING_STATUS_COMPLETED = "MEETING_STATUS_COMPLETED";
exports.MEETING_TYPE_KEY = {
    KDM: "MEETING_TYPE_KDM",
    FINAL_NEGOTIATION: "MEETING_TYPE_FINAL_NEGOTIATION",
    HANDOVER: "MEETING_TYPE_HANDOVER",
};
exports.MEETING_NAME = {
    KDM: "KDM Meeting",
    FINAL_NEGOTIATION: "Final Negotiation Meeting",
    HANDOVER: "Handover Meeting",
};
exports.OPPORTUNITY_POLICY_STATUS_CREATED = "OPPORTUNITY_POLICY_STATUS_CREATED";
exports.POLICY_CONFIG_STATUS_IN_PROGRESS = "POLICY_CONFIG_STATUS_IN_PROGRESS";
exports.ENROLLMENT_STATUS_NOT_READY = "ENROLLMENT_STATUS_NOT_READY";
exports.PREFERENCE_STATUS_PREFERRED = "PREFERENCE_STATUS_PREFERRED";
exports.PREFERENCE_STATUS_EXCLUDED = "PREFERENCE_STATUS_EXCLUDED";
exports.DUPLICATE_CONSTRAINT = {
    duplicatePanEntry: "unique_pan_card_number",
    duplicateTanEntry: "unique_tan_number",
    duplicateGstinEntry: "company_gst_detail_gst_number_key",
};
exports.SUCCESS_MESSAGE = "SUCCESS";
exports.DEFAULT_ACTIVE_STATUS = "Active";
exports.DEFAULT_INACTIVE_STATUS = "Inactive";
exports.DEFAULT_COMPANY_STATUS_ACTIVE = "COMPANY_STATUS_ACTIVE";
exports.OPPORTUNITY_STATUS_OPEN = "OPPORTUNITY_STATUS_OPEN";
exports.OPPORTUNITY_STATUS_LOST = "OPPORTUNITY_STATUS_LOST";
exports.OPPORTUNITY_STATUS_WORK_IN_PROGRESS = "OPPORTUNITY_STATUS_WORK_IN_PROGRESS";
exports.OPPORTUNITY_STATUS_WON = "OPPORTUNITY_STATUS_WON";
exports.OPPORTUNITY_ACTIVITY_STATUS_CLOSED = "OPPORTUNITY_ACTIVITY_STATUS_CLOSED";
exports.OPPORTUNITY_POLICY_STATUS_ACTIVE = "OPPORTUNITY_POLICY_STATUS_ACTIVE";
exports.QCR_GENERATION_KEY = "quote_comparison_report_activity";
exports.DEFAULT_CONTACT_STATUS_ACTIVE_KEY = "CONTACT_STATUS_ACTIVE";
exports.DEFAULT_CONTACT_STATUS_INACTIVE_KEY = "CONTACT_STATUS_INACTIVE";
exports.DEFAULT_BROKER_STATUS_ACTIVE = "BROKER_ACTIVE";
exports.DEFAULT_INSURER_STATUS_ACTIVE_KEY = "INSURER_STATUS_ACTIVE";
exports.DEFAULT_RESIDENTIAL_ADDRESS_TYPE_KEY = "Residential";
exports.DEFAULT_TPA_STATUS_ACTIVE_KEY_ID = 80;
exports.DEFAULT_CONTACT_STATUS_ACTIVE_KEY_ID = 29;
exports.DEFAULT_CONTACT_STATUS_INACTIVE_KEY_ID = 30;
exports.DEFAULT_COMPANY_STATUS_UNDER_REVIEW_KEY_ID = 33;
exports.DEFAULT_INSURER_STATUS_ACTIVE_KEY_ID = 85;
exports.DEFAULT_BROKER_STATUS_ACTIVE_KEY_ID = 274;
exports.companyNonEditableFields = ["companyName"];
exports.EMPLOYEE_STATUS_ACTIVE = "EMPLOYEE_STATUS_ACTIVE";
exports.EMPLOYEE_STATUS_INACTIVE = "EMPLOYEE_STATUS_INACTIVE";
exports.EMPLOYEE_STATUS_LEAVE = "EMPLOYEE_STATUS_LEAVE";
exports.USER_STATUS_ACTIVE = "USER_STATUS_ACTIVE";
exports.USER_STATUS_DELETED = "USER_STATUS_INACTIVE";
exports.OPTY_STAGE_WIP = "OPTY_STAGE_WIP";
exports.OPTY_STAGE_OPEN = "OPTY_STAGE_OPEN";
exports.OPTY_STAGE_LOST = "OPTY_STAGE_LOST";
exports.OPTY_STAGE_WON = "OPTY_STAGE_WON";
exports.ACTIVITY_STATUS_COMPLETED = "ACTIVITY_STATUS_COMPLETED";
exports.EMPLOYEE_REPORTEE_ACTION_REASSIGN = "EMPLOYEE_REPORTEE_ACTION_REASSIGN";
exports.EMPLOYEE_REPORTEE_ACTION_IGNORE = "EMPLOYEE_REPORTEE_ACTION_IGNORE";
exports.EMPLOYEE_REPORTEE_ACTION_UPDATE = "EMPLOYEE_REPORTEE_ACTION_UPDATE";
exports.DEFAULT_PHONE_KEY = "phone";
exports.DEFAULT_EMAIL_KEY = "email";
exports.COMPANY_DISPLAY_NAME = "displayName";
exports.DEFAULT_COMPANY_ENTITY_NAME = "Company";
exports.DEFAULT_CONTACT_ENTITY_NAME = "Contact";
exports.DEFAULT_INSURER_ENTITY_NAME = "Insurer";
exports.DEFAULT_TPA_ENTITY_NAME = "Tpa";
exports.DEFAULT_BROKER_ENTITY_NAME = "Broker";
exports.TPA_STATUS_ACTIVE = "TPA_STATUS_ACTIVE";
exports.KNOWLEDGE_STATUS_ACTIVE = "KNOWLEDGE_STATUS_ACTIVE";
exports.KNOWLEDGE_STATUS_DELETED = "KNOWLEDGE_STATUS_DELETED";
exports.MEETING_SUB_TYPE_LID = "MEETING_SUBTYPE_HANDOVER";
exports.UPDATE = "update";
exports.IGNORE = "ignore";
exports.REASSIGN = "reassign";
exports.DEFAULT_APPROVAL_REQUIRED = "No";
exports.EMPLOYEE_FIELDS = {
    CREATED_AT: "createdAt",
    UPDATED_AT: "updatedAt",
    CREATED_BY: "createdBy",
    UPDATED_BY: "updatedBy",
    STATUS_LID: "statusLid",
    ORGANIZATION_LID: "organizationLid",
    BRANCH_LID: "branchLid",
    DEPARTMENT_ID: "departmentId",
    DESIGNATION_ID: "designationId",
    LOCATION_ID: "locationId",
    VERTICAL_ID: "verticalId",
    IWORK_ROLE_ID: "iworkRoleId",
    REPORTING_USER_ID: "reportingUserId",
    REPORTING_MANAGER_EMPLOYEE_ID: "reportingManagerEmployeeId",
    STATUS_LOOKUP: "statusLookup",
    SALUTATION_LID: "salutationLid",
    ROLE_ID: "roleId",
    DELETED_AT: "deletedAt",
};
exports.COMPANY_CONTACT_RECORD_TYPE = 88;
exports.INSURER_CONTACT_RECORD_TYPE = 89;
exports.TPA_CONTACT_RECORD_TYPE = 90;
exports.BROKER_CONTACT_RECORD_TYPE = 91;
var enumRecordType;
(function (enumRecordType) {
    enumRecordType["COMPANY"] = "company";
    enumRecordType["TPA"] = "tpa";
    enumRecordType["INSURER"] = "insurer";
    enumRecordType["BROKER"] = "broker";
})(enumRecordType || (exports.enumRecordType = enumRecordType = {}));
exports.DEFAULT_PHONE_NUMBER = 9000000001;
exports.CREATED_AT = "createdAt";
exports.DEFAULT_TOTAL_KPI_COUNT = 0;
exports.LOOK_UP_DATA = {
    addressTypeLid: ["ADDRESS_TYPE", "AGENT_ADDRESS_TYPE"],
    isLifeLid: "INSURER_IS_LIFE",
    companyTagLid: "COMPANY_TAG",
    companyTypeLid: "COMPANY_TYPE",
    industrySegmentLid: "INDUSTRY_SEGMENT",
    priorityLid: "PRIORITY",
    statusLid: [
        "COMPANY_STATUS",
        "USER_STATUS",
        "EMPLOYEE_STATUS",
        "TPA_STATUS",
        "INSURER_STATUS",
        "CONTACT_STATUS",
        "OPPORTUNITY_STATUS",
        "OPPORTUNITY_ACTIVITY_STATUS",
        "BROKER_STATUS",
        "TOGGLE_TYPE",
        "ACTIVITY_SUBMISSION_STATUS",
        "MEETING_STATUS",
    ],
    quoteStatusLid: "OPPORTUNITY_ACTIVITY_STATUS",
    reasonForLossLid: "REASON_FOR_OPPORTUNITY_LOSS",
    kdmMeetingTypeLid: "SELECT_MEETING",
    handOverMeetingTypeLid: "SELECT_MEETING",
    isFinalNegotiationTypeLid: "SELECT_MEETING",
    sentimentLid: "SENTIMENT_TYPE",
    sourceTypeLid: "COMPANY_SOURCE_TYPE",
    groupCompanyLid: "GROUP_COMPANY",
    gstCategoryLid: "TAX",
    salutation: "SALUTATION",
    iworkRole: "IIRM_ROLE",
    addressType: "ADDRESS_TYPE",
    contactRecordTypeLid: "CONTACT_RECORD_TYPE",
    salutationLid: "SALUTATION",
    tagLid: ["CONTACT_TAG", "AGENT_CONTACT_TAG"],
    contactTypeLid: ["CONTACT_TYPE", "AGENT_CONTACT_TYPE"],
    gender: "GENDER_TYPE",
    spouseWorkingStatus: "SPOUSE_WORKING_STATUS",
    maritalStatus: "MARTIAL_STATUS",
    policyTypeLid: "POLICY_TYPE",
    policyStatusLid: "POLICY_STATUS",
    stageLid: "STAGE",
    serviceLevelLid: "SERVICE_LEVEL",
    challengeTypeLid: "CHALLENGE_TYPE",
    mitigationTypeLid: "MITIGATION_TYPE",
    relationshipTypeLid: "RELATIONSHIP_TYPE",
    childGender: "GENDER_TYPE",
    opportunityTypeLid: "OPPORTUNITY_TYPE",
    isPolicyMinedLid: "IS_POLICY_MINED",
    opportunitySourceTypeLid: "OPPORTUNITY_SOURCE_TYPE",
    iworkRoleId: "IWORK_ROLE",
    policyPlacedTypeLid: "POLICY_PLACED_TYPE",
    serviceLevelAgreementDaysLid: "SERVICE_NO_OF_DAYS",
    onlyLeadPaysCommissionLid: "ONLY_LEAD_PAYS_COMMISSION",
    wouldChangeQuoteValuesLid: "WOULD_YOU_LIKE_TO_CHANGE_VALUES",
    activityTypeLid: "ACTIVITY_TYPE",
    meetingTypeLid: "MEETING_TYPE",
    meetingStatusLid: "MEETING_STATUS",
    locationTypeLid: "MEETING_LOCATION",
    mandateTypeLid: "MANDATE_TYPE",
    documentTypeLid: "DOCUMENT_TYPE",
    policyDataWrongLid: "TOGGLE_TYPE",
    deviationResolvedLid: "TOGGLE_TYPE",
    isLeadInsurerPayCommissionLid: "TOGGLE_TYPE",
    resolutionLid: "RESOLUTION_TYPE",
    policyDataRectifiedLid: "TOGGLE_TYPE",
    placementSlipDeviationsLid: "TOGGLE_TYPE",
    deviationsAddressedLid: "TOGGLE_TYPE",
    revisedHeldCoverNoteLid: "TOGGLE_TYPE",
    compensationTypeLid: "COMPENSATION_TYPE",
    deviationsLid: "TOGGLE_TYPE",
    deviationCoveragesLid: "TOGGLE_TYPE",
    policyHardCopyReceivedLid: "TOGGLE_TYPE",
    taskStatusLid: "TASK_STATUS",
    taskTypeLid: "TASK_TYPE",
    preferenceTypeLid: "PREFERENCE_STATUS",
    paymentTypeLid: "PAYMENT_TOGGLE",
    cdAccountTypeLid: "CD_ACCOUNT_TOGGLE",
    transactionTypeLid: "TRANSACTION_TYPE",
};
exports.MASTER_DATA = {
    leadCrm: "user",
    accountManager: "user",
    cityId: "city",
    stateId: "state",
    countryId: "country",
    currencyId: "currency",
    designationId: "designation",
    organisationLid: "organisation",
};
exports.OPPORTUNITY_STAGES = [
    "STAGE_CREATED",
    "STAGE_LOST",
    "STAGE_MOVE_ON",
    "STAGE_UNDER_REVIEW",
];
exports.OPPORTUNITY_TYPES = ["OPPORTUNITY_TYPE_SO", "OPPORTUNITY_TYPE_RO"];
exports.TPA_MEDIATOR_TYPE = 100;
exports.INSURER_MEDIATOR_TYPE = 101;
exports.MEDIATOR_TYPES = {
    [exports.TPA_MEDIATOR_TYPE]: "TPA",
    [exports.INSURER_MEDIATOR_TYPE]: "INSURER",
};
exports.MEDIATOR_DETAILS = {
    TPA_MEDIATOR_TYPE: "TPA",
    INSURER_MEDIATOR_TYPE: "INSURER",
};
exports.THREE_MONTHS = "3 Months";
exports.SIX_MONTHS = "6 Months";
exports.ONE_YEAR = "1 Year";
exports.TWO_YEARS = "2 Years";
exports.FIVE_YEARS = "5 Years";
exports.AccessControlMap = {
    getOpportunities: [
        { categoryKey: "OPTY_TPA_001", actionKey: "READ_001" },
        { categoryKey: "CMP_TPA_001", actionKey: "WRITE_001" },
    ],
    updateOpportunity: [
        { categoryKey: "OPY_TPA_001", actionKey: "UPDATE_001" },
        { categoryKey: "CMP_TPA_001", actionKey: "WRITE_001" },
    ],
};
exports.TABLE_NAMES = {
    STAGE_ACTIVITY_TEMPLATE: "mstr_stage_activity_template",
    MSTR_ACTIVITY: "mstr_activity",
    MSTR_STAGE: "mstr_stage",
    OPPORTUNITY_ACTIVITY_MAP: "opportunity_activity_map",
    LOOKUP_DATA: "lookup_data",
    OPPORTUNITY_ACTIVITY_PARTICIPANTS: "opportunity_activity_participants",
    OPPORTUNITY_PREMIUM_CALCULATION: "OpportunityPremiumCalculation",
    OPPORTUNITY_RFP_DETAILS_ENTRY: "opportunity_rfp_details_entry",
    USER: "users",
    EMPLOYEE: "employee"
};
exports.MAPPED_DATA_DELETION = {
    MAP_REMOVED: "mapping_removed",
    SOFT_DELETE: "deleted_at",
};
exports.PARTICIPANT_TYPE = {
    TPA_CONTACT: "TPA_CONTACT",
    INSURER_CONTACT: "INSURER_CONTACT",
    BROKER_CONTACT: "BROKER_CONTACT",
    COMPANY_CONTACT: "COMPANY_CONTACT",
    EMPLOYEE: "EMPLOYEE",
};
exports.PARTICIPANT_EMPLOYEE_COMPANY_ID = 0;
exports.COVERS_REQUIRED_ACTIVITIES = [
    "RFP Data Collection",
    "Broking Slip Generation",
    "Enter Quote",
    "QCR Generation",
    "Placement Slip Generation",
    "Meeting for Final Negotiation",
    "Held Cover Note",
    "Premium Calculation",
    "Policy Hard Copy Receipt",
];
exports.SALES_OPPORTUNITY = "SO";
exports.RENEWAL_OPPORTUNITY = "RO";
exports.DEFAULT_COMPANY_CONTACT_RECORD_TYPE = -1;
exports.DEFAULT_COMPANY_CONTACT_RECORD_TYPE_KEY = "COMPANY_CONTACT_RECORD_TYPE";
exports.DEFAULT_PLANNING = {
    PLANNED: "Planned",
    NOT_PLANNED: "Not Planned",
};
exports.USER_EMAIL = "emailId";
exports.ORGANISATION_ID = 'organisationId';
exports.EMPLOYEE_USER_ID = 'userId';
exports.ACTIVITY_KEY = {
    POLICY_CONFIRMATION_ACTIVITY: "policy_confirmation_activity",
    OPPORTUNITY_LOST_ACTIVITY: "opportunity_lost_activity",
    HAND_OVER_MEET_ACTIVITY: "hand_over_meet_activity",
    POLICY_DOCKET_ACTIVITY: "policy_docket_activity",
    POLICY_HARD_COPY_ACTIVITY: "policy_hard_copy_activity",
    HELD_COVER_NOTE_ACTIVITY: "held_cover_note_activity",
    PREMIUM_CALCULATION_ACTIVITY: "premium_calculation_activity",
    PLACEMENT_SLIP_GENERATION_ACTIVITY: "placement_slip_generation_activity",
    FINAL_NEGOTIATION_ACTIVITY: "final_negotiation_activity",
    QUOTE_COMPARISON_REPORT_ACTIVITY: "quote_comparison_report_activity",
    QUOTE_ENTRY_ACTIVITY: "quote_entry_activity",
    BROKING_SLIP_ACTIVITY: "broking_slip_activity",
    RFP_DETAILS_ENTRY_ACTIVITY: "rfp_details_entry_activity",
    RFP_COVER_DETAIL_ACTIVITY: "rfp_cover_detail_activity",
    MANDATE_DETAILS_ENTRY_ACTIVITY: "mandate_details_entry_activity",
    KDM_MEETING_ACTIVITY: "kdm_meeting_activity",
    DATA_VALIDATION_ACTIVITY: "data_validation_activity",
};
exports.OPPORTUNITY_ACTIVITY = {
    DATA_VALIDATION: "opportunity_data_validation",
    KDM_MEETING: "opportunity_kdm_meeting",
    MANDATE_DETAILS_ENTRY: "opportunity_mandate_details_entry",
    RFP_COVER_DETAIL: "opportunity_rfp_cover_detail",
    RFP_DETAILS_ENTRY: "opportunity_rfp_details_entry",
    BROKING_SLIP: "opportunity_broking_slip_version_details",
    QUOTE_ENTRY: "opportunity_quote_entry",
    QUOTE_COMPARISON_REPORT: "opportunity_quote_comparison_report",
    FINAL_NEGOTIATION: "opportunity_final_negotiation",
    PLACEMENT_SLIP: "opportunity_placement_slip_generation",
    PREMIUM_CALCULATION: "opportunity_premium_calculation",
    HELD_COVER_NOTE: "opportunity_held_cover_note",
    POLICY_HARD_COPY: "opportunity_policy_hard_copy",
    POLICY_DOCKET: "opportunity_policy_docket",
    HAND_OVER_MEET: "opportunity_hand_over_meet",
    LOST: "opportunity_lost",
    POLICY_CONFIRMATION: "opportunity_policy_confirmation",
};
// Smart Search - Employee Hierarchy regex
exports.EMPLOYEE_ID_FOR_HIERARCHY_TREE_REGEX = /ownedBy:\[(\d+)\]/;
exports.SEARCH_STRING_FOR_OPPORTUNITIES_FETCH_REGEX = /,?ownedBy:\[\d+\]/;
